
function FeatureDetailsBanner({ data }) {
    return (
        <div className='bg-white w-full h-60 rounded-4xl shadow-xl pr-10 flex'>
            <div className='bg-gradient-to-l to-[#4F7A9C] from-[#1C2327] shadow-xl w-2/3 h-full rounded-4xl p-10'>
                <div className='flex flex-col w-full h-full justify-between'>
                    <div className='text-white w-full truncate text-2xl 3xl:text-3xl 5xl:text-4xl'>{data?.feature_name}</div>
                    <div className='flex divide-gray-400'>
                        <div>
                            <div className='text-white text-lg 5xl:text-xl line-clamp-2'>{data?.feature_description}</div>
                            <div className='text-[#D3D3D3] text-sm 5xl:text-lg'>feature description</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='w-1/3 flex flex-col justify-between items-end py-10'>
                <div className="text-lg text-right pl-4 5xl:text-xl text-[#042E77] font-semibold">Accounts</div>
                <div>
                    <div className={`w-full truncate text-black text-lg text-right pl-4 5xl:text-xl`}>Production</div>
                    <div className='text-sm text-[#707070] 5xl:text-xl'>Status of this feature</div>
                </div>
            </div>
        </div>
    )
}

export default FeatureDetailsBanner